<template>
  <div>
    <el-card>
      <el-steps :active="setupActive" align-center finish-status="success" class="mb20">
        <el-step :title="$t('text.groupSetting')"></el-step>
        <el-step :title="$t('text.members')"></el-step>
      </el-steps>
      <alter-form :customeButton="true" :watchImageVisible="false" @handleChange="handleChange" ref="alterForm"
        @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength">
        <template v-slot:customeButton="data">
          <el-row type="flex" justify="center" style="margin-top: 10px">
            <el-button @click="handleCancelClick">{{ $t('button.cancel') }}</el-button>
            <el-button type="primary" @click="formSubmit(data)">{{ btnTxt }}</el-button>
          </el-row>
        </template>
      </alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineCouponEdit from './index.js'
export default onlineCouponEdit
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
